module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-02.4b186a59.jpg";